import { Fragment } from 'libs/react';
import { React } from 'libs/react';
import { getColumns } from 'components/table/private/schema';
import { TableCell } from 'components/table/private/TableCell';
import { TableLabel } from 'components/table/private/TableLabel';
import './TableHeaders.scss';
/**
 * @component TableHeaders
 * @since 1.0.0
 * @hidden
 */
export function TableHeaders(props) {
    const { schema } = props;
    const columns = getColumns(schema);
    return (React.createElement(Fragment, null, columns.map((column) => {
        var _a, _b, _c, _d;
        return (React.createElement(TableCell, { key: column, style: column, align: (_a = schema[column]) === null || _a === void 0 ? void 0 : _a.align, column: (_b = schema[column]) !== null && _b !== void 0 ? _b : undefined },
            React.createElement(TableLabel, { title: (_c = schema[column]) === null || _c === void 0 ? void 0 : _c.header, infos: (_d = schema[column]) === null || _d === void 0 ? void 0 : _d.infos, field: column })));
    })));
}
